// src/utils/main.js
// Importowanie wspólnych komponentów i modułów
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Autoplay, Navigation, Pagination, Scrollbar } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/autoplay';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import DialogVideo from '../components/Dialog/DialogVideo.vue';
import DialogLightbox from '../components/Dialog/DialogLightbox.vue';
import Specialists from '../components/Specialists/Specialists.vue';
import Services from '../components/Services/Services.vue';
import CalculatorFertility from '../components/Calculators/CalculatorFertility.vue';
// Eksportowanie komponentów i modułów do użycia w innych plikach
export const swiperModules = [
    Autoplay,
    Navigation,
    Pagination,
    Scrollbar
];
export const sharedComponents = {
    DialogVideo,
    DialogLightbox,
    Specialists,
    Services,
    CalculatorFertility,
    Swiper,
    SwiperSlide
};
export const sharedElementPlusComponents = {
    ElButton,
    ElCheckbox,
    ElCheckboxButton,
    ElCheckboxGroup,
    ElCollapse,
    ElCollapseItem,
    ElDialog,
    ElPagination,
    ElPopover,
    ElRadio,
    ElRadioButton,
    ElRadioGroup,
    ElTabs,
    ElTabPane,
    ElTag,
    ElLoading
};
